const debug =
  process.env.NODE_ENV === 'development'
    ? (namespace) =>
        (...msg) =>
          // eslint-disable-next-line no-console
          console.debug(namespace, ...msg)
    : () => () => null

export default debug
